// import { NgModule } from '@angular/core';
// import { RouterModule, Routes } from '@angular/router';
// import { AuthGuard } from './auth.guard';
// import { NoAuthGuard } from './no-auth.guard'; // Import the new guard
// import { FullComponent } from './layouts/full/full.component';
// import { VendorsComponent } from './partners/vendors/vendors.component';
// import { VendorSignupComponent } from './partners/vendors/vendor-signup/vendor-signup.component';
// import { CustomersComponent } from './partners/customers/customers.component';
// import { BriefComponent } from './pages/brief/brief.component';
// import { EmailResponsesComponent } from './partners/email-responses/email-responses.component';
// import { CustomerRegisterFormComponent } from './pages/chatbot/customer-register-form/customer-register-form.component';
// import { VendorDashboardComponent } from './pages/vendor-dashboard/vendor-dashboard.component';
// import { VendorSigninComponent } from './partners/vendors/vendor-signin/vendor-signin.component';
// import { CustomerSigninComponent } from './partners/customers/customer-signin/customer-signin.component';
// import { CustomerForgotPasswordComponent } from './partners/customers/customer-forgot-password/customer-forgot-password.component';
// import { CustomerResetPasswordComponent } from './partners/customers/customer-reset-password/customer-reset-password.component';
// const routes: Routes = [
//   {
//     path: '',
//     component: FullComponent,
//     children: [
//       {
//         path: '',
//         redirectTo: '/workspace/projects', // Default route
//         pathMatch: 'full',
//       },
//       {
//         path: 'login',
//         loadChildren: () =>
//           import('./pages/authentication/authentication.module').then(
//             (m) => m.AuthenticationModule
//           ),
//         canActivate: [NoAuthGuard], // Apply NoAuthGuard to /login
//       },
//       {
//         path: 'brief',
//         component: BriefComponent,
//         data: {
//           title: 'Brief',
//         },
//         canActivate: [AuthGuard], // Protect this route
//       },
//       {
//         path: 'workspace',
//         loadChildren: () =>
//           import('./pages/pages.module').then((m) => m.PagesModule),
//         canActivate: [AuthGuard], // Protect this route
//       },
//       {
//         path: 'vendors',
//         component:VendorDashboardComponent,
//         data: {
//           title: 'Starter Page',
//         },
//         canActivate: [AuthGuard], // Protect this route
//       },
//       {
//         path: 'vendors/signup',
//         component: VendorSignupComponent,
//         data: {
//           title: 'Vendor Signup',
//         },
//         canActivate: [AuthGuard], // Protect this route
//       },
//       {
//         path: 'vendors/login',
//         component: VendorSigninComponent,
//         data: {
//           title: 'Vendor Login',
//         },
//         // canActivate: [NoAuthGuard], // Protect this route
//       },
//       {
//         path: 'vendors/signup/kulture-katta',
//         component: VendorSignupComponent,
//         data: {
//           title: 'Kulture Katta Signup',
//         },
//         canActivate: [AuthGuard], // Protect this route
//       },
//       {
//         path: 'vendors/dashboard',
//         component: VendorDashboardComponent,
//         data: {
//           title: 'Vendor Dashboard',
//         },
//         canActivate: [AuthGuard], // Protect this route
//       },
//       {
//         path: 'vendors/signup/modern-software-architecture',
//         component: VendorSignupComponent,
//         data: {
//           title: 'Modern Software Architecture Signup',
//         },
//         canActivate: [AuthGuard], // Protect this route
//       },
//       {
//         path: 'customers',
//         component: CustomersComponent,
//         data: {
//           title: 'Starter Page',
//         },
//         canActivate: [AuthGuard], // Protect this route
//       },
//       {
//         path: 'email-responses',
//         component: EmailResponsesComponent,
//         data: {
//           title: 'Email Response',
//         },
//       },
//       {
//         path: 'customers/signup',
//         component: CustomerRegisterFormComponent,
//       },
//       {
//         path: 'customers/login',
//         component: CustomerSigninComponent,
//         data: {
//           title: 'customers Login',
//         },
//         // canActivate: [NoAuthGuard], // Protect this route
//       },
//       {
//         path: 'customer/forgot-password',
//         component: CustomerForgotPasswordComponent,
//       },
//       {
//         path: 'reset-password',
//         component: CustomerResetPasswordComponent,
//       },
//     ],
//   },
//   { path: '**', redirectTo: '/login' }, // Redirect to login for any unknown routes
// ];

// @NgModule({
//   imports: [RouterModule.forRoot(routes)],
//   exports: [RouterModule],
// })
// export class AppRoutingModule {}
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './auth.guard';
import { NoAuthGuard } from './no-auth.guard';
import { RestrictedEmailGuard } from './restricted-email.guard';
import { FullComponent } from './layouts/full/full.component';
import { VendorsComponent } from './partners/vendors/vendors.component';
import { VendorSignupComponent } from './partners/vendors/vendor-signup/vendor-signup.component';
import { CustomersComponent } from './partners/customers/customers.component';
import { BriefComponent } from './pages/brief/brief.component';
import { EmailResponsesComponent } from './partners/email-responses/email-responses.component';
import { VendorDashboardComponent } from './pages/vendor-dashboard/vendor-dashboard.component';
import { VendorSigninComponent } from './partners/vendors/vendor-signin/vendor-signin.component';
import { CustomerSigninComponent } from './partners/customers/customer-signin/customer-signin.component';
import { CustomerSignupComponent } from './partners/customers/customer-signup/customer-signup.component';
import { CustomerForgotPasswordComponent } from './partners/customers/customer-forgot-password/customer-forgot-password.component';
import { CustomerResetPasswordComponent } from './partners/customers/customer-reset-password/customer-reset-password.component';
import { AuthCallbackComponentComponent } from './partners/customers/auth-callback-component/auth-callback-component.component';
import { VendorRegisterComponent } from './partners/vendors/vendor-register/vendor-register.component';
import { VendorChangePasswordComponent } from './partners/vendors/vendor-change-password/vendor-change-password.component';

const routes: Routes = [
  {
    // Public share URL — the token is opaque + shareable, no auth required.
    // Matches the URL Laravel generates in generateShareLink:
    //   {VENDOR_FRONT_URL}/public/portfolio/{encryptedToken}
    path: 'portfolio',
    loadChildren: () =>
      import('./pages/portfolio-page/portfolio-page.module').then((m) => m.PortfolioPageModule),
  },
  {
    path: '',
    component: FullComponent,
    children: [
      {
        path: '',
        redirectTo: '/workspace/projects',
        pathMatch: 'full',
      },
      {
        path: 'login',
        loadChildren: () =>
          import('./pages/authentication/authentication.module').then(
            (m) => m.AuthenticationModule
          ),
        canActivate: [NoAuthGuard], // Apply NoAuthGuard
      },
      {
        path: 'brief',
        component: BriefComponent,
        data: { title: 'Brief' },
        canActivate: [AuthGuard],
      },
      {
        path: 'workspace',
        loadChildren: () =>
          import('./pages/pages.module').then((m) => m.PagesModule),
        canActivate: [AuthGuard],
      },
      {
        // Locked to prodcontroller@studioip.ai via RestrictedEmailGuard so
        // the URL can't be typed in to bypass the menu hide. Real internal
        // users still pass through AuthGuard as before.
        path: 'vendors',
        component: VendorsComponent,
        data: { title: 'Starter Page' },
        canActivate: [AuthGuard, RestrictedEmailGuard],
      },
      {
        path: 'vendors/signup',
        component: VendorSignupComponent,
        data: { title: 'Vendor Signup' },
        canActivate: [AuthGuard],
      },
      {
        path: 'vendors/login',
        component: VendorSigninComponent,
        data: { title: 'Vendor Login' },
        canActivate: [NoAuthGuard],
      },
      {
        path: 'vendors/register',
        component: VendorRegisterComponent,
        data: { title: 'Vendor Register' },
        canActivate: [NoAuthGuard],
      },
      {
        path: 'change-password/:token',
        component: VendorChangePasswordComponent,
        data: { title: 'Reset Password' },
      },
      {
        path: 'vendors/signup/kulture-katta',
        component: VendorSignupComponent,
        data: { title: 'Kulture Katta Signup' },
        canActivate: [AuthGuard],
      },
      {
        path: 'vendors/dashboard',
        redirectTo: '/workspace/vendor/dashboard',
        pathMatch: 'full',
      },
      {
        path: 'vendors/signup/modern-software-architecture',
        component: VendorSignupComponent,
        data: { title: 'Modern Software Architecture Signup' },
        canActivate: [AuthGuard],
      },
      {
        path: 'customers/profile',
        component: CustomersComponent,
        data: { title: 'Starter Page' },
        canActivate: [NoAuthGuard],
      },
      {
        path: 'email-responses',
        component: EmailResponsesComponent,
        data: { title: 'Email Response' },
      },
      {
        path: 'customers/signup',
        component: CustomerSignupComponent,
        data: { title: 'Customers Signup' },
        canActivate: [NoAuthGuard],
      },
      {
        path: 'customers/login',
        component: CustomerSigninComponent,
        data: { title: 'Customers Login' },
        canActivate: [NoAuthGuard], // Apply NoAuthGuard here too
      },
      {
        path: 'customer/forgot-password',
        component: CustomerForgotPasswordComponent,
        canActivate: [NoAuthGuard], // Apply NoAuthGuard here too
      },
      {
        path: 'reset-password',
        component: CustomerResetPasswordComponent,
        canActivate: [NoAuthGuard], // Apply NoAuthGuard here too
      },
       {
        path: 'v1/auth/callback',
        component: AuthCallbackComponentComponent,
        canActivate: [NoAuthGuard], // Apply NoAuthGuard here too
      },
      {
        path: 'open-bid',
        loadChildren: () =>
          import('./pages/open-bid/open-bid.module').then((m) => m.OpenBidModule),
        data: { title: 'Open Bids' },
        // No auth guard — publicly accessible
      },
    ],
  },
  { path: '**', redirectTo: '/login' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}